/**
 * Bexly Bundle Tiers
 *
 * The tier cards are a skin over the theme's real variant picker. Clicking a card
 * checks the matching native radio and dispatches `change` on it, which hands control
 * back to the theme: variant-picker.js updates the URL and refetches the section,
 * product-form.js rewrites input[name="id"], product-price.js repaints the price and
 * sticky-add-to-cart.js morphs the sticky bar. Nothing here writes those directly —
 * doing so would leave the price, the URL and Shop Pay out of sync with the cart.
 *
 * A custom element (not an inline script) because morph.js does not re-execute inline
 * scripts inside a morphed subtree, and this block lives inside one.
 */
class BexlyBundleTiers extends HTMLElement {
  connectedCallback() {
    this.handleChange = this.handleChange.bind(this);
    this.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    const card = event.target;
    if (!card || !card.matches('[data-bexly-variant]')) return;

    const variantId = card.dataset.bexlyVariant;
    if (!variantId) return;

    const scope = this.closest('.shopify-section') || document;
    const nativeRadio = scope.querySelector(
      'variant-picker input[data-variant-id="' + variantId + '"]'
    );

    if (nativeRadio) {
      if (nativeRadio.checked) return;
      nativeRadio.checked = true;
      // The listener lives on <variant-picker>, not on the input, and programmatic
      // .checked changes do not emit `change` on their own.
      nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Degrade to "right product in the cart, stale UI" rather than "wrong pack bought".
    const form = scope.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form && form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;
    console.warn('[bexly-bundle-tiers] No native variant radio found for ' + variantId + '. Is the variant-picker block present in the buy box?');
  }
}

if (!customElements.get('bexly-bundle-tiers')) {
  customElements.define('bexly-bundle-tiers', BexlyBundleTiers);
}
